import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3beb1883&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3beb1883')) {
      api.createRecord('3beb1883', component.options)
    } else {
      api.reload('3beb1883', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3beb1883&", function () {
      api.rerender('3beb1883', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SystemMaintenance/components/basicConfig/bpmApprovalProcessAdvanceSetting/index.vue"
export default component.exports